import axios from 'axios';

const APIKit = axios.create({
  timeout: 20000,
  headers: {
    'Content-Type': 'application/json',
    'Accept-Language': 'en',
    'X-Encrypted': false,
  },
  withCredentials: true,
  baseURL: `${process.env.REACT_APP_API_URL}`,
  validateStatus: (status: number) => status >= 200 && status < 400,
});

export const changeLanguageHeader = (language: string) => {
  APIKit.defaults.headers.common['Accept-Language'] = language ?? 'en';
};

export { APIKit };